import { createSlice } from "@reduxjs/toolkit";
import { getAllCreators, requestJobToCreator } from "./spotlightService";

// Initial state
const initialState = {
  creators: [],
  loading: false,
  error: null,
  jobRequests: [],
};

// Spotlight slice
const spotlightSlice = createSlice({
  name: "spotlight",
  initialState,
  reducers: {
    clearSpotlightErrors: (state) => {
      state.error = null;
    },
    clearSpotlightData: (state) => {
      state.creators = [];
      state.loading = false;
      state.error = null;
      state.jobRequests = [];
    },
  },
  extraReducers: (builder) => {
    // Get All Creators
    builder
      .addCase(getAllCreators.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCreators.fulfilled, (state, action) => {
        state.loading = false;
        state.creators = action.payload.data;
      })
      .addCase(getAllCreators.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Request Job to Creator
      .addCase(requestJobToCreator.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestJobToCreator.fulfilled, (state, action) => {
        state.loading = false;
        state.jobRequests = [...state.jobRequests, action.payload.data];
      })
      .addCase(requestJobToCreator.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSpotlightErrors, clearSpotlightData } =
  spotlightSlice.actions;
export default spotlightSlice.reducer;
